import React from 'react'
import cx from 'classnames'
import actions from 'redux/actions'

import s from './Link.scss'


const SEOLink = ({ children, className, to }) => (
  <a
    className={cx(s.link, className)}
    href={to}
    onClick={() => actions.view.smartSearchPage.closeFiltersOverlay()}
  >
    {children}
  </a>
)

export default SEOLink
